import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { emailCustomInterface } from 'src/app/util/interfaces/emailCustom';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class CustomEmailsService {
	private getFieldsByTypeEmailUrl = environment.baseApiUrl + 'customEmail/fields/{emailType}';
	private getTypesEmailUrl = environment.baseApiUrl + 'customEmail/typesEmail';
	private postCustomEmailUrl = environment.baseApiUrl + 'customEmail/saveCustomEmail';
	private getEmailsLanguageByEmailType = environment.baseApiUrl + 'customEmail/emailsLanguages/{emailType}';
	private putSetEmailSendingStatusUrl = environment.baseApiUrl + 'customEmail/setEmailSendingStatus';
	private updateCustomEmailUrl = environment.baseApiUrl + 'customEmail/updateCustomEmail/{id}';
	private deleteCustomEmailUrl = environment.baseApiUrl + 'customEmail/deleteCustomEmail/{id}';
	private getCustomEmailValuesUrl = environment.baseApiUrl + 'customEmail/customEmailValues';

	constructor(
		private httpClient: HttpClient,
		private AuthLoginService: AuthLoginService
	) {}

	getFields(emailType: string): Observable<any[]> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const getFieldsByTypeEmailUrl = this.getFieldsByTypeEmailUrl.replace('{emailType}', emailType);
		return this.httpClient.get<emailCustomInterface[]>(getFieldsByTypeEmailUrl, { headers: headers }).pipe(
			map((column: any) => {
				const newLogsArray: emailCustomInterface[] = [];
				column.forEach((column) => {
					const newLog: emailCustomInterface = {
						label: column.label,
						parameter: `§_${column.parameter}_§`,
						tLabel: column.tLabel,
					};
					newLogsArray.push(newLog);
				});
				return newLogsArray;
			})
		);
	}

	getAllTypesEmail(): Observable<any[]> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		return this.httpClient.get<any[]>(this.getTypesEmailUrl, { headers: headers });
	}

	postCustomEmail(emailBody: emailCustomInterface): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const body = {
			email_type: emailBody.emailType,
			label: emailBody.label,
			language: emailBody.language,
			text_area: emailBody.textContent,
			usertype: emailBody.userType === '' ? 'analyst' : 'enduser',
		};

		return this.httpClient.post(this.postCustomEmailUrl, body, { headers: headers });
	}

	getEmailsLanguageByTypeEmail(emailType: string): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const getEmailsLanguageByEmailType = this.getEmailsLanguageByEmailType.replace('{emailType}', emailType);
		return this.httpClient.get<any[]>(getEmailsLanguageByEmailType, { headers: headers });
	}

	setEmailSendingStatus(emailType: string, active: number): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const putSetEmailSendingStatusUrl = `${this.putSetEmailSendingStatusUrl}?emailType=${emailType}`;
		const body = { active: active };

		return this.httpClient.put(putSetEmailSendingStatusUrl, body, { headers: headers });
	}

	updateCustomEmail(id: string, bodyData: emailCustomInterface): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const updateCustomEmailUrl = this.updateCustomEmailUrl.replace('{id}', id);
		const body = {
			text_area: bodyData.textContent,
			usertype: bodyData.userType,
			email_type: bodyData.emailType,
			language: bodyData.language,
		};

		return this.httpClient.put<any>(updateCustomEmailUrl, body, { headers: headers });
	}

	deleteCustomEmail(id: string): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const deleteCustomEmailUrl = this.deleteCustomEmailUrl.replace('{id}', id);

		return this.httpClient.delete<any>(deleteCustomEmailUrl, { headers: headers });
	}

	getCustomEmailValues(id: string): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const getCustomEmailValuesUrl = `${this.getCustomEmailValuesUrl}?id=${id}`;

		return this.httpClient.get<emailCustomInterface>(getCustomEmailValuesUrl, { headers: headers });
	}
}
